import React, { useState } from "react";

import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import backendApi from "@/api/backendApi";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";

export default function ResumeHeadlineSection({ profile }) {
  const queryClient = useQueryClient();
  const [isEditing, setIsEditing] = useState(false);
  const [headline, setHeadline] = useState(profile.resume_headline || "");

  const updateMutation = useMutation({
    mutationFn: (newHeadline) => backendApi.entities.UserProfile.updateHeadline(newHeadline),
    onSuccess: () => {
      queryClient.invalidateQueries(["userProfile"]);
      setIsEditing(false);
    },
  });

  const handleSave = () => {
    updateMutation.mutate(headline);
  };

  return (
    <div className="bg-white rounded-xl shadow-sm p-6">
      <div className="flex items-center justify-between">
        <h3 className="text-lg font-semibold text-gray-800">Resume headline</h3>
        <button 
          onClick={() => setIsEditing(true)}
          className="text-blue-600 hover:underline text-sm font-medium"
        >
          {!!profile?.resume_headline ? "Edit" : "Add"}
        </button>
      </div>

      <p className="text-gray-600 mt-2">
        {profile.resume_headline ||
          "Job seeker with B.Tech/B.E. currently living in Hyderabad, Telangana"}
      </p>

      {/* EDIT POPUP */}
      <Dialog open={isEditing} onOpenChange={setIsEditing}>
        <DialogContent className="max-w-lg">
          <DialogHeader>
            <DialogTitle>Edit Resume Headline</DialogTitle>
          </DialogHeader>

          <div className="space-y-4">
            <Textarea
              value={headline}
              onChange={(e) => setHeadline(e.target.value)}
              placeholder="e.g. Experienced Software Engineer with 5+ years of experience in React and Node.js..."
              className="min-h-[120px]"
            />

            <p className="text-sm text-gray-500">
              A clear headline helps you stand out in search results.
            </p>

            <div className="flex justify-end gap-2">
              <Button variant="outline" onClick={() => setIsEditing(false)}>
                Cancel
              </Button>
              <Button 
                onClick={handleSave} 
                disabled={updateMutation.isPending}
              >
                {updateMutation.isPending ? "Saving..." : "Save"}
              </Button>
            </div>
          </div>
        </DialogContent>
      </Dialog>
    </div>
  );
}
